export default __webpack_public_path__ + "static/media/Managers.272edc09.svg";